module.exports = __webpack_public_path__ + "img/PRNT_00_mono_AE_00001.4712ed13.png";